import { Resource as e } from "@coveo/platform-client";
//#region src/resources/AutomationFreezesResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/indexautomation/freezes";
	}
	listFreezes() {
		return this.api.get(t.baseUrl);
	}
};
//#endregion
export { t as AutomationFreezesResource };

//# sourceMappingURL=AutomationFreezesResource.js.map